/**
 * Minimal object pool. `acquire` reuses a released object (after `reset`) before creating a new one,
 * so steady-state spawning allocates nothing. `created` never exceeds the peak concurrent use.
 */
export class Pool<T> {
  private readonly free: T[] = [];
  private inUseCount = 0;
  private createdCount = 0;

  constructor(
    private readonly create: () => T,
    private readonly reset: (item: T) => void = () => {},
  ) {}

  acquire(): T {
    let item = this.free.pop();
    if (item === undefined) {
      item = this.create();
      this.createdCount++;
    }
    this.reset(item);
    this.inUseCount++;
    return item;
  }

  release(item: T): void {
    this.free.push(item);
    this.inUseCount--;
  }

  get created(): number {
    return this.createdCount;
  }
  get inUse(): number {
    return this.inUseCount;
  }
  get available(): number {
    return this.free.length;
  }
}
